const COLOR = {
  primary: '#F4B56E',
  secondary: '#FFF0D2',
  text: '#1A1A1A',
  whiteText: '#FFFFFF',
  textSecondary: '#CC8C43',
  captionText: '#777777',
  heading: '#1A1A1A',
  content: '#855115',
  line: '#C1C1C1',
  background: '#FFF0D2',
  whiteBackground: '#FFFFFF',
  menuText: '#1A1A1A',
  border: '#F5F5F5',
  success: '#46B450',
  nagative: '#CC3C2B',
  warning: '#FFB900',
  overlay: 'rgba(0, 0, 0, 0.4)',
  disable: '#EBEBEB'
};

export default COLOR;
